//NBL1_Staff Pages
import rules from "../../Data/Rules"
import functions from "../../Data/Functions"
import settings from "../Settings/BIGV_Settings"
import Verification from "../Steps/Verification"
import Base_Details from "../Steps/BaseDetails"
import store from "../../veux/store"

let Associations, Clubs
let step1, step2


// BIGV Delegate Step Schema
const Load_BIGV_Delegate_Steps = () => {
    return {
        Portal: '2024 BIGV Delegate',
        // MainColor: "#0305a1",
        MainColor: "#f5924c",
        Logo: require(`../../assets/BigVLogoNewT.png`),
        Title: `<h2>Big V Delegate Registration Form</h2>`,
        Description: ``,
        Model: {},
        steps: [
            // Step 1
            step1,
            // Step 2
            step2,
            // Step 3
            {
                stepno: 3,
                title: 'Rego',
                valid: true,
                information: '',
                Schema: {
                    Association: {
                        type: "select",
                        label: "Association?",
                        outlined: true,
                        dense: true,
                        rules: [rules.requiredMsg('Association is Required')],
                        class: 'mx-1 px-1',
                        items: Associations,
                        returnObject: true,
                        itemText: 'Detail',
                        Role: 13,
                        Accreditation: 7095,
                        AccredStart: '',
                        AccredEnd: '',
                        AccredTeam: 3223,
                        OUG: { Contact_Roles: true, Type: "Associations" }
                    },
                },
                PreStep: (thisStep, portal) => {
                    let { Model, Schema } = thisStep
                },
            },
            // Step 4
            {
                stepno: 4,
                title: 'Finalisation',
                valid: true,
                information: `Thank you for your submitted registration for the 2024 Big V season.<br></br>
                            Please note this submitted registration is <b>PENDING APPROVAL</b> from the 
                            league and you and your Association Delegate will receive an email notification 
                            once your registration has been reviewed and approved by the league.<br></br>
                            If your registration has not been approved the league will contact your 
                            Association Delegate to inform them of any further requirements to meet 
                            league eligibility approval for the season.<br></br>

                            <b>Please note that if your registration has been submitted during the 
                            season after 4pm on the Friday prior to a weekends round your 
                            registration will NOT be reviewed and/or approved until the following 
                            round as you have missed that weekends round deadline to submit your 
                            registration.</b>
                            <hr><br></br>


                            Please stay up to date with all Big V news and information throughout the season on the <a href="https://www.basketballvictoria.com.au/bigv/home" target="blank">Big V website</a><br></br>
                            Please also note the number of games required to be played per division to qualify for finals
                            <a href="https://admin.ownurgoal.net.au/_lib/file/doc/2024_Finals_Qualification_Requirements.pdf" target="blank">2024 Big V Finals Qualification</a>`,
                Model: {},
                Schema: {}
            }
        ]
    }
}

export default {

    LoadSchema: async (Parameters) => {
        step1 = await Verification.LoadSchema(1)
        step2 = await Base_Details.LoadSchema(2)
        Associations = await functions.GetCodeBy({ State_Champs: 3223, Type: "Associations" }, true)
        return Load_BIGV_Delegate_Steps()
    },

}